








import axios from "axios";
import { Vue, Component } from "vue-property-decorator";

@Component
export default class Legal extends Vue {
    private linkEula = require("@/assets/pdf/legal.pdf");

    public mounted(): void {
        this.download();
    }

    private download(): void {
        axios({
            url: this.linkEula,
            method: "GET",
            responseType: "blob",
        }).then(response => {
            const fileURL = window.URL.createObjectURL(new Blob([response.data]));
            const fileLink = document.createElement("a");

            fileLink.href = fileURL;
            fileLink.setAttribute("download", "legal.pdf");
            document.body.appendChild(fileLink);

            fileLink.click();
        });
    }
}
